export enum PaymentMethodsLabels {
  CASH = "Cash",
  CHEQUE = "Cheque",
  ONLINE = "Online",
}

export enum PaymentMethodsValues {
  CASH = "cash",
  CHEQUE = "check",
  QR = "qr",
}

export enum ReimbursedLabels {
  DONE = "Done",
  PENDING = "Pending",
}
